import TrinhLanhDao from './chuyen-vien-nhap-lieu/TrinhLanhDao.jsx';
import TrinhLanhDaoView from './chuyen-vien-nhap-lieu/TrinhLanhDaoView.jsx';
import TruongPhongGiaoViec from './truong-phong/TruongPhongGiaoViec.jsx';
import TruongPhongGiaoViecView from './truong-phong/TruongPhongGiaoViecView.jsx';
import LanhDaoGiaoViec from './lanh-dao/LanhDaoGiaoViec.jsx';
import LanhDaoGiaoViecView from './lanh-dao/LanhDaoGiaoViecView.jsx'
import HuongXuLy from './chuyen-vien/HuongXuLy.jsx';
import HuongXuLyView from './chuyen-vien/HuongXuLyView.jsx';
import KhongCoQuyTrinh from './khong-co-quy-trinh/KhongCoQuyTrinh.jsx';
import TuXuLy from './tu-xu-ly/TuXuLy.jsx';

export {
  TrinhLanhDao,
  TrinhLanhDaoView,
  TruongPhongGiaoViec,
  TruongPhongGiaoViecView,
  LanhDaoGiaoViec,
  LanhDaoGiaoViecView,
  HuongXuLy,
  HuongXuLyView,
  KhongCoQuyTrinh,
  TuXuLy
}



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-xu-ly/index.js